import React from 'react';
import cn from 'clsx';

import Link from '../../library/link/link';
import StarRating, { RatingLink } from '../../library/star-rating/star-rating';

import styles from './product-rating.scss';

interface ProductRatingProps {
  avgReviewRating: number;
  className?: string;
  hideRating?: boolean;
  link?: string;
  linkText?: string;
  numberOfReviews: number;
  onReadReviewClick: () => void;
  productCode?: string | null;
  rearProductCode?: string | null;
  showCompareReviews?: boolean;
  showCount?: boolean;
}

function ProductRating(props: ProductRatingProps) {
  const {
    avgReviewRating,
    className = '',
    hideRating = false,
    link,
    linkText,
    numberOfReviews,
    onReadReviewClick,
    productCode,
    rearProductCode,
    showCompareReviews,
    showCount = true
  } = props;

  return (
    <div
      className={cn(styles['reviews'], `product-rating ${className}`)}
      data-testid="product-rating"
    >
      <StarRating
        className={styles['star-rating']}
        hideRating={hideRating}
        rating={avgReviewRating}
      />
      <RatingLink
        className="rating-link"
        count={numberOfReviews}
        defaultText="No reviews yet"
        href={link}
        linkText={linkText}
        onClick={onReadReviewClick}
        showCount={showCount}
      />
      {showCompareReviews && (
        <Link
          className="rating-link"
          to={`/review/product/comparison?allVehicles=true&productCode=${productCode}${
            rearProductCode ? `&rearProductCode=${rearProductCode}` : ''
          }`}
        >
          Compare Reviews
        </Link>
      )}
    </div>
  );
}

export default ProductRating;
